import { AnimatePresence, motion } from 'framer-motion';

import { Icon } from '../icon';

interface FactPopupProps {
  isOpen: boolean;
  toggleDrawer: () => void;
  children: React.ReactNode;
  position: 'left' | 'right';
  width?: string;
  obscureBackground?: boolean;
  maxHeight?: string;
}

export const FactPopup = ({
  isOpen,
  toggleDrawer,
  children,
  position,
  width = '525px',
  obscureBackground = false,
  maxHeight,
}: FactPopupProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {obscureBackground && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.3 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="fixed inset-0 z-40 bg-black"
              onClick={toggleDrawer}
            ></motion.div>
          )}
          {/* Drawer */}
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ x: position === 'left' ? '-200%' : '100%' }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            style={{ width: width, ...(maxHeight && { maxHeight }) }}
            className={`fixed bottom-5 ${position === 'left' ? 'left-12' : 'right-2'} z-40 max-w-full ${maxHeight ? 'overflow-auto' : ''} rounded-lg border bg-white p-2 shadow-xl`}
          >
            <div className="flex flex-col">
              <button
                className="absolute top-2 right-2 z-10 p-0.75 text-xl text-gray-600 hover:text-gray-800"
                onClick={toggleDrawer}
              >
                <Icon className="lucide--x" />
              </button>

              <AnimatePresence mode="wait">
                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: -20, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  {children}
                </motion.div>
              </AnimatePresence>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
